var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f78d20",
    d: "M500 250a250 250 0 0 1-250 250A250 250 0 0 1 0 250 250 250 0 0 1 250 0a250 250 0 0 1 250 250z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M250 0C140.5 106 56 226.4 40.8 387c72.2 14.5 121.6 25.3 209.3 25.3 88 0 148.7-11 209.5-25.4C444 226 359.5 106 250 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#024589",
    d: "M102 349.2L250 75.4l148 273.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtec);
export default __webpack_public_path__ + "static/media/protec.91da6896ec556ffb8eaf1dcab9ee9e26.svg";
export { ForwardRef as ReactComponent };